import { Grid, Typography } from 'vendor/material';
import { Link, Loader } from '@tackle-io/platform-ui';
import { makeStyles } from 'vendor/material';
import { useAmpliFeatureFlags } from '@tackle-io/tackle-auth-tools';
import { Redirect } from 'react-router-dom';
import MsftLogo from './assets/MsftLogo';
import ConfigureMsftCosell from './components/ConfigureMsftCosell';

const useStyles = makeStyles((theme) => ({
  breadcrumbIntegrations: {
    paddingBottom: '20px',
    marginLeft: theme.spacing(2),
    color: theme.palette.NEUTRAL900,
    textDecoration: 'none',
    '& > a': {
      textDecoration: 'none',
      '&:hover': {
        color: theme.palette.BLUE400,
      },
      '&:visited': {
        textDecoration: 'none',
        color: theme.palette.NEUTRAL900,
      },
    },
  },
  breadcrumbDivider: {
    marginLeft: theme.spacing(3),
  },
  headerGrid: {
    marginLeft: theme.spacing(2),
    paddingLeft: theme.typography.pxToRem(100),
    marginTop: theme.typography.pxToRem(50),
    marginBottom: theme.typography.pxToRem(50),
  },
  headerTitle: {
    color: theme.palette.NEUTRAL700,
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4),
  },
  configContainer: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  marginLeft20: {
    marginLeft: theme.spacing(2),
  },
}));

const MsftCosellIntegrations = () => {
  const classes = useStyles();

  const { loading: ampliLoading, flags: ampliFlags } = useAmpliFeatureFlags();
  if (ampliLoading) {
    return <Loader />;
  }
  const isCloudConnectorEnabled =
    ampliFlags['cloud-connector-aws-integrations'] === 'on';

  if (!isCloudConnectorEnabled) {
    return <Redirect to="/integrations" />;
  }

  const handleAfterCompleted = (cloud: string) => {
    // This function is called when configuration is complete
    console.log(`${cloud} co-sell configuration completed`);
  };

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      data-testid="msft-cosell-integrations"
    >
      <Grid item xs={12} className={classes.headerGrid}>
        <span className={classes.breadcrumbDivider}>{'<'}</span>
        <Link
          to="/integrations"
          aria-label="breadcrumb"
          className={classes.breadcrumbIntegrations}
        >
          Integrations
        </Link>
        <Grid container>
          <Grid item className={classes.marginLeft20}>
            <MsftLogo />
          </Grid>
          <Grid item>
            <Typography className={classes.headerTitle} variant="h4">
              Microsoft Marketplace
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.configContainer}>
          <ConfigureMsftCosell onAfterCompleted={handleAfterCompleted} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MsftCosellIntegrations;
